import React, { useState } from 'react';
import { getPublicImagePath } from '@nutastic/nutastic-react-app';
import PageSlider from '../PageSlider';
import VideoPlayer from '../VideoPlayer';

const ComingSoonPage = () => {
    const [currentVideo, setCurrentVideo] = useState(null);
    const componentClass = 'coming-soon-page';

    const slides = [
        { title: 'It Must Be Wednesday: Vol.2', img: getPublicImagePath('covers/wednesday--v2.jpg'), video: null, href: 'https://music.apple.com/us/album/it-must-be-wednesday-vol-2/1880526980' },
        { title: "Grindin' So Long", img: getPublicImagePath('wednesday-covers/2026-02-18--GrindingSoLong.jpg'), video: 'g3aKTEA0T9s' },
        { title: "Let's Go", img: getPublicImagePath('wednesday-covers/2026-02-12--LetsGo.jpg'), video: 'aVesWmEtBXI' },
        { title: 'Spend My Day', img: getPublicImagePath('wednesday-covers/2026-01-21.jpg'), video: 'n2NMhzJAzA0' },
        { title: 'It Must Be Wednesday: Vol.1', img: getPublicImagePath('covers/wednesday--v1.jpg'), video: null, href: 'https://music.apple.com/us/artist/tron-legac/1279461405' },
        { title: 'Captain Speaking', img: getPublicImagePath('wednesday-covers/2024-06-19--CaptainSpeaking.jpg'), video: 'BQQINHgQ6Qc' },
        { title: 'Marathon Burger', img: getPublicImagePath('wednesday-covers/cover--marathonBurger.jpg'), video: 'LSwWTWQEljA' },
        { title: 'TronLegac.com', img: getPublicImagePath('wed-cover.jpg'), video: null, href: 'https://www.youtube.com/@tronlegac/videos' }
    ];

    const oldSlides = [
        { title: 'Life Is A Stage', img: getPublicImagePath('wednesday-covers/2024-07-03--LifeIsAStsge.jpg'), video: '_C0MwTdVr9Y' },
        { title: 'Letter To Hip Hop', img: getPublicImagePath('wednesday-covers/2024-06-26--LetterToHipHop.jpg'), video: 'Pw54vztrsbM' },
        { title: 'Captain Speaking', img: getPublicImagePath('wednesday-covers/2024-06-19--CaptainSpeaking.jpg'), video: 'BQQINHgQ6Qc' },
        { title: 'Go', img: getPublicImagePath('wednesday-covers/2024-06-12--Go.jpg'), video: 'BikLFRF652o' },
        { title: 'Best I Go', img: getPublicImagePath('wednesday-covers/2024-06-05--BestIGo.jpg'), video: 'Z8Xs-8Z31hM' },
        { title: 'Million Dollar Baby', img: getPublicImagePath('wednesday-covers/2024-05-29--MillionDollarBaby.jpg'), video: 'Djsb6icS7XA' },
        { title: 'Friends', img: getPublicImagePath('wednesday-covers/2024-05-22--Friends.jpg'), video: 'W_Q0sZgy6hg' }
    ];

    return <React.Fragment>
        <header className={`${componentClass}__header`}>
            <img src={getPublicImagePath('tron-logo.png')} alt='TronLegac Logo Emblem' />
        </header>
        <PageSlider slides={slides} onSlideClick={v => setCurrentVideo(v)} shouldDisableGlitch={true} />
        <VideoPlayer videoId={currentVideo} onClose={() => setCurrentVideo(null)} />
    </React.Fragment>;
};

export default ComingSoonPage;
